import { POINT_LEDGER_STATUS } from '../common/name-space';

export const pointLedgerStatusFilter = (aData: number): string => {
  let re = null;
  switch (aData) {
    case POINT_LEDGER_STATUS.MINE:
      re = '채굴';
      break;
    case POINT_LEDGER_STATUS.REFERRAL:
      re = '추천인';

      break;
    case POINT_LEDGER_STATUS.BONUS:
      re = '보너스';
      break;
    case POINT_LEDGER_STATUS.REFERRAL_MY:
      re = '피추천인';
      break;
    default:
      re = '';
      break;
  }
  return re;
};
